import React from 'react';
import { SubsidiaryHeader } from '../../../components/shared/SubsidiaryHeader';
import { SubsidiaryFooter } from '../../../components/shared/SubsidiaryFooter';
const navigation = [{
  name: 'Home',
  href: '/unique-buka'
}, {
  name: 'Menu',
  href: '#menu'
}, {
  name: 'About',
  href: '#about'
}, {
  name: 'Gallery',
  href: '#gallery'
}, {
  name: 'Events',
  href: '#events'
}, {
  name: 'Contact',
  href: '#contact'
}];
const footerLinks = [{
  title: 'Dining',
  items: [{
    name: 'Our Menu',
    href: '#'
  }, {
    name: 'Reservations',
    href: '#'
  }, {
    name: 'Special Events',
    href: '#'
  }, {
    name: 'Catering',
    href: '#'
  }]
}, {
  title: 'Company',
  items: [{
    name: 'About Us',
    href: '#'
  }, {
    name: 'Our Chefs',
    href: '#'
  }, {
    name: 'Careers',
    href: '#'
  }, {
    name: 'Gallery',
    href: '#'
  }]
}];
const featuredDishes = [{
  id: 'jollof',
  name: 'Signature Jollof Rice',
  description: 'Aromatic rice cooked in rich tomato sauce with traditional spices, served with your choice of protein.',
  price: 18.99,
  image: 'https://images.unsplash.com/photo-1604329760661-e71dc83f8f26?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
}, {
  id: 'egusi',
  name: 'Egusi Soup with Pounded Yam',
  description: 'Melon seed soup cooked with spinach, spices, and assorted meats, served with smooth pounded yam.',
  price: 22.99,
  image: 'https://images.unsplash.com/photo-1643456370478-80b12f115af5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1974&q=80'
}, {
  id: 'suya',
  name: 'Suya Platter',
  description: 'Skewered beef grilled to perfection with our special suya spice mix, served with fresh onions and tomatoes.',
  price: 24.99,
  image: 'https://images.unsplash.com/photo-1544025162-d76694265947?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80'
}, {
  id: 'moimoi',
  name: 'Moi Moi Deluxe',
  description: 'Steamed bean pudding with fish, eggs, and vegetables, perfectly seasoned for a delightful taste.',
  price: 16.99,
  image: 'https://images.unsplash.com/photo-1596797038530-2c107aa7e1f3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
}];
const galleryImages = ['https://images.unsplash.com/photo-1555396273-367ea4eb4db5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2074&q=80', 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80', 'https://images.unsplash.com/photo-1600335895229-6e75511892c8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80', 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80', 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80', 'https://images.unsplash.com/photo-1551218808-94e220e084d2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'];
export function UniqueBukaHome() {
  return <div className="flex flex-col min-h-screen" data-id="element-1205">
      <SubsidiaryHeader name="Unique Buka" color="bg-red-50 text-red-900" navigation={navigation} logo="https://uploadthingy.s3.us-west-1.amazonaws.com/jzok4tARJt4mLq8xyZse5t/UNIQUE.png" data-id="element-1206" />
      <main className="flex-grow" data-id="element-1207">
        {/* Hero Section */}
        <section className="relative h-[70vh]" data-id="element-1208">
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')] bg-cover bg-center" data-id="element-1209"></div>
          <div className="absolute inset-0 bg-red-900/60" data-id="element-1210"></div>
          <div className="relative z-10 container mx-auto px-4 h-full flex items-center" data-id="element-1211">
            <div className="max-w-xl text-white" data-id="element-1212">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" data-id="element-1213">
                Authentic Nigerian Cuisine
              </h1>
              <p className="text-xl md:text-2xl mb-8" data-id="element-1214">
                Experience the rich flavors and traditions of Nigeria in a
                modern dining setting.
              </p>
              <div className="flex flex-wrap gap-4" data-id="element-1215">
                <a href="#menu" className="px-6 py-3 bg-red-600 text-white font-medium rounded-md hover:bg-red-700 transition-colors" data-id="element-1216">
                  View Menu
                </a>
                <a href="#reservations" className="px-6 py-3 bg-transparent border border-white text-white font-medium rounded-md hover:bg-white/10 transition-colors" data-id="element-1217">
                  Make a Reservation
                </a>
              </div>
            </div>
          </div>
        </section>
        {/* Menu Section */}
        <section id="menu" className="py-20" data-id="element-1218">
          <div className="container mx-auto px-4" data-id="element-1219">
            <h2 className="text-3xl font-bold text-center text-red-900 mb-16" data-id="element-1220">
              Featured Dishes
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1221">
              {featuredDishes.map(dish => <div key={dish.id} className="flex flex-col md:flex-row bg-white rounded-lg shadow-md overflow-hidden" data-id="element-1222">
                  <div className="md:w-2/5" data-id="element-1223">
                    <img src={dish.image} alt={dish.name} className="w-full h-full object-cover" data-id="element-1224" />
                  </div>
                  <div className="md:w-3/5 p-6" data-id="element-1225">
                    <h3 className="text-xl font-bold text-red-900 mb-2" data-id="element-1226">
                      {dish.name}
                    </h3>
                    <p className="text-gray-700 mb-4" data-id="element-1227">{dish.description}</p>
                    <div className="flex justify-between items-center" data-id="element-1228">
                      <span className="text-xl font-bold text-red-700" data-id="element-1229">
                        ${dish.price}
                      </span>
                      <a href="#" className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors" data-id="element-1230">
                        Order Now
                      </a>
                    </div>
                  </div>
                </div>)}
            </div>
            <div className="mt-12 text-center" data-id="element-1231">
              <a href="#" className="px-6 py-3 bg-red-600 text-white font-medium rounded-md hover:bg-red-700 transition-colors inline-block" data-id="element-1232">
                View Full Menu
              </a>
            </div>
          </div>
        </section>
        {/* About Section */}
        <section id="about" className="py-20 bg-red-50" data-id="element-1233">
          <div className="container mx-auto px-4" data-id="element-1234">
            <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-1235">
              <div className="lg:w-1/2" data-id="element-1236">
                <h2 className="text-3xl font-bold text-red-900 mb-6" data-id="element-1237">
                  Our Story
                </h2>
                <p className="text-gray-700 mb-6" data-id="element-1238">
                  Unique Buka was established in 2015 with a simple mission: to
                  bring authentic Nigerian cuisine to a wider audience while
                  preserving traditional cooking methods and flavors.
                </p>
                <p className="text-gray-700 mb-6" data-id="element-1239">
                  Our founder, Chef Amara Okafor, grew up learning family
                  recipes passed down through generations. After studying
                  culinary arts internationally, she returned to Nigeria with a
                  vision to elevate local cuisine while staying true to its
                  roots.
                </p>
                <p className="text-gray-700 mb-6" data-id="element-1240">
                  Today, Unique Buka is known for its exceptional food, warm
                  atmosphere, and commitment to using locally-sourced
                  ingredients. Each dish tells a story of Nigeria's rich
                  culinary heritage.
                </p>
                <div className="grid grid-cols-2 gap-4" data-id="element-1241">
                  <div className="bg-white p-4 rounded-lg shadow-sm" data-id="element-1242">
                    <h3 className="text-xl font-bold text-red-700" data-id="element-1243">
                      Our Ingredients
                    </h3>
                    <p className="text-gray-700" data-id="element-1244">
                      Locally sourced, fresh, and authentic to create genuine
                      Nigerian flavors.
                    </p>
                  </div>
                  <div className="bg-white p-4 rounded-lg shadow-sm" data-id="element-1245">
                    <h3 className="text-xl font-bold text-red-700" data-id="element-1246">
                      Our Chefs
                    </h3>
                    <p className="text-gray-700" data-id="element-1247">
                      Skilled culinary experts trained in traditional cooking
                      techniques.
                    </p>
                  </div>
                </div>
              </div>
              <div className="lg:w-1/2" data-id="element-1248">
                <img src="https://images.unsplash.com/photo-1581299894007-aaa50297cf16?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1974&q=80" alt="Chef preparing food" className="rounded-lg shadow-lg w-full" data-id="element-1249" />
              </div>
            </div>
          </div>
        </section>
        {/* Gallery Section */}
        <section id="gallery" className="py-20" data-id="element-1250">
          <div className="container mx-auto px-4" data-id="element-1251">
            <h2 className="text-3xl font-bold text-center text-red-900 mb-16" data-id="element-1252">
              Gallery
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-1253">
              {galleryImages.map((image, index) => <div key={index} className="overflow-hidden rounded-lg shadow-md group" data-id="element-1254">
                  <img src={image} alt={`Gallery image ${index + 1}`} className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-1255" />
                </div>)}
            </div>
          </div>
        </section>
        {/* Events & Catering Section */}
        <section id="events" className="py-20 bg-red-50" data-id="element-1256">
          <div className="container mx-auto px-4" data-id="element-1257">
            <h2 className="text-3xl font-bold text-center text-red-900 mb-16" data-id="element-1258">
              Events & Catering
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1259">
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-1260">
                <div className="text-4xl text-red-600 mb-4" data-id="element-1261">🎉</div>
                <h3 className="text-xl font-bold text-red-900 mb-3" data-id="element-1262">
                  Private Events
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-1263">
                  Host your special occasion at Unique Buka. We offer customized
                  menus and private dining spaces for birthdays, anniversaries,
                  corporate events, and more.
                </p>
                <ul className="mb-6 space-y-2" data-id="element-1264">
                  <li className="flex items-center" data-id="element-1265">
                    <span className="text-red-600 mr-2" data-id="element-1266">✓</span>
                    <span className="text-gray-700" data-id="element-1267">
                      Private dining room for up to 30 guests
                    </span>
                  </li>
                  <li className="flex items-center" data-id="element-1268">
                    <span className="text-red-600 mr-2" data-id="element-1269">✓</span>
                    <span className="text-gray-700" data-id="element-1270">
                      Customized menus for your event
                    </span>
                  </li>
                  <li className="flex items-center" data-id="element-1271">
                    <span className="text-red-600 mr-2" data-id="element-1272">✓</span>
                    <span className="text-gray-700" data-id="element-1273">
                      Special decorations available
                    </span>
                  </li>
                  <li className="flex items-center" data-id="element-1274">
                    <span className="text-red-600 mr-2" data-id="element-1275">✓</span>
                    <span className="text-gray-700" data-id="element-1276">
                      Dedicated event coordinator
                    </span>
                  </li>
                </ul>
                <a href="#" className="inline-block px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors" data-id="element-1277">
                  Book an Event
                </a>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-1278">
                <div className="text-4xl text-red-600 mb-4" data-id="element-1279">🍽️</div>
                <h3 className="text-xl font-bold text-red-900 mb-3" data-id="element-1280">
                  Catering Services
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-1281">
                  Bring the flavors of Unique Buka to your location. Our
                  catering services are perfect for corporate events, weddings,
                  family gatherings, and more.
                </p>
                <ul className="mb-6 space-y-2" data-id="element-1282">
                  <li className="flex items-center" data-id="element-1283">
                    <span className="text-red-600 mr-2" data-id="element-1284">✓</span>
                    <span className="text-gray-700" data-id="element-1285">
                      Full-service catering available
                    </span>
                  </li>
                  <li className="flex items-center" data-id="element-1286">
                    <span className="text-red-600 mr-2" data-id="element-1287">✓</span>
                    <span className="text-gray-700" data-id="element-1288">
                      Buffet and plated service options
                    </span>
                  </li>
                  <li className="flex items-center" data-id="element-1289">
                    <span className="text-red-600 mr-2" data-id="element-1290">✓</span>
                    <span className="text-gray-700" data-id="element-1291">
                      Equipment rental available
                    </span>
                  </li>
                  <li className="flex items-center" data-id="element-1292">
                    <span className="text-red-600 mr-2" data-id="element-1293">✓</span>
                    <span className="text-gray-700" data-id="element-1294">
                      Professional staff for service
                    </span>
                  </li>
                </ul>
                <a href="#" className="inline-block px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors" data-id="element-1295">
                  Inquire About Catering
                </a>
              </div>
            </div>
          </div>
        </section>
        {/* Reservations Section */}
        <section id="reservations" className="py-20" data-id="element-1296">
          <div className="container mx-auto px-4" data-id="element-1297">
            <h2 className="text-3xl font-bold text-center text-red-900 mb-16" data-id="element-1298">
              Make a Reservation
            </h2>
            <div className="max-w-2xl mx-auto bg-white p-8 rounded-lg shadow-md" data-id="element-1299">
              <form data-id="element-1300">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-1301">
                  <div data-id="element-1302">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1303">
                      Name
                    </label>
                    <input type="text" id="name" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none" data-id="element-1304" />
                  </div>
                  <div data-id="element-1305">
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1306">
                      Phone
                    </label>
                    <input type="tel" id="phone" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none" data-id="element-1307" />
                  </div>
                </div>
                <div className="mb-4" data-id="element-1308">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1309">
                    Email
                  </label>
                  <input type="email" id="email" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none" data-id="element-1310" />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-1311">
                  <div data-id="element-1312">
                    <label htmlFor="date" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1313">
                      Date
                    </label>
                    <input type="date" id="date" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none" data-id="element-1314" />
                  </div>
                  <div data-id="element-1315">
                    <label htmlFor="time" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1316">
                      Time
                    </label>
                    <input type="time" id="time" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none" data-id="element-1317" />
                  </div>
                </div>
                <div className="mb-4" data-id="element-1318">
                  <label htmlFor="guests" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1319">
                    Number of Guests
                  </label>
                  <select id="guests" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none" data-id="element-1320">
                    <option value="1" data-id="element-1321">1 person</option>
                    <option value="2" data-id="element-1322">2 people</option>
                    <option value="3" data-id="element-1323">3 people</option>
                    <option value="4" data-id="element-1324">4 people</option>
                    <option value="5" data-id="element-1325">5 people</option>
                    <option value="6" data-id="element-1326">6 people</option>
                    <option value="7+" data-id="element-1327">7+ people</option>
                  </select>
                </div>
                <div className="mb-6" data-id="element-1328">
                  <label htmlFor="special" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1329">
                    Special Requests
                  </label>
                  <textarea id="special" rows={3} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none" data-id="element-1330"></textarea>
                </div>
                <button type="submit" className="w-full py-3 px-4 bg-red-600 text-white font-medium rounded-md hover:bg-red-700 transition-colors" data-id="element-1331">
                  Reserve a Table
                </button>
              </form>
            </div>
          </div>
        </section>
        {/* Contact Section */}
        <section id="contact" className="py-20 bg-red-50" data-id="element-1332">
          <div className="container mx-auto px-4" data-id="element-1333">
            <h2 className="text-3xl font-bold text-center text-red-900 mb-16" data-id="element-1334">
              Contact Us
            </h2>
            <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1335">
              <div data-id="element-1336">
                <h3 className="text-xl font-bold text-red-900 mb-4" data-id="element-1337">
                  Visit Us
                </h3>
                <div className="space-y-4 mb-8" data-id="element-1338">
                  <div className="flex items-start" data-id="element-1339">
                    <span className="text-red-600 mr-4" data-id="element-1340">📍</span>
                    <div data-id="element-1341">
                      <p className="font-medium" data-id="element-1342">Address</p>
                      <p className="text-gray-700" data-id="element-1343">
                        123 Foodie Street
                        <br data-id="element-1344" />
                        Lekki, Lagos
                        <br data-id="element-1345" />
                        Nigeria
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-1346">
                    <span className="text-red-600 mr-4" data-id="element-1347">📞</span>
                    <div data-id="element-1348">
                      <p className="font-medium" data-id="element-1349">Phone</p>
                      <p className="text-gray-700" data-id="element-1350">+234 456 789 0123</p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-1351">
                    <span className="text-red-600 mr-4" data-id="element-1352">✉️</span>
                    <div data-id="element-1353">
                      <p className="font-medium" data-id="element-1354">Email</p>
                      <p className="text-gray-700" data-id="element-1355">info@uniquebuka.com</p>
                    </div>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-red-900 mb-4" data-id="element-1356">Hours</h3>
                <ul className="space-y-2 text-gray-700" data-id="element-1357">
                  <li data-id="element-1358">
                    <span className="font-medium" data-id="element-1359">Monday - Thursday:</span>{' '}
                    11:00 AM - 10:00 PM
                  </li>
                  <li data-id="element-1360">
                    <span className="font-medium" data-id="element-1361">Friday - Saturday:</span>{' '}
                    11:00 AM - 11:00 PM
                  </li>
                  <li data-id="element-1362">
                    <span className="font-medium" data-id="element-1363">Sunday:</span> 12:00 PM - 9:00
                    PM
                  </li>
                </ul>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-1364">
                <h3 className="text-xl font-bold text-red-900 mb-4" data-id="element-1365">
                  Send Us a Message
                </h3>
                <form data-id="element-1366">
                  <div className="mb-4" data-id="element-1367">
                    <label htmlFor="contact-name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1368">
                      Name
                    </label>
                    <input type="text" id="contact-name" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none" data-id="element-1369" />
                  </div>
                  <div className="mb-4" data-id="element-1370">
                    <label htmlFor="contact-email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1371">
                      Email
                    </label>
                    <input type="email" id="contact-email" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none" data-id="element-1372" />
                  </div>
                  <div className="mb-4" data-id="element-1373">
                    <label htmlFor="contact-subject" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1374">
                      Subject
                    </label>
                    <input type="text" id="contact-subject" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none" data-id="element-1375" />
                  </div>
                  <div className="mb-4" data-id="element-1376">
                    <label htmlFor="contact-message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1377">
                      Message
                    </label>
                    <textarea id="contact-message" rows={4} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none" data-id="element-1378"></textarea>
                  </div>
                  <button type="submit" className="w-full py-2 px-4 bg-red-600 text-white font-medium rounded-md hover:bg-red-700 transition-colors" data-id="element-1379">
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
      <SubsidiaryFooter name="Unique Buka" description="Authentic Nigerian cuisine celebrating local flavors and traditions." color="bg-red-900" textColor="text-white" links={footerLinks} logo="https://uploadthingy.s3.us-west-1.amazonaws.com/jzok4tARJt4mLq8xyZse5t/UNIQUE.png" data-id="element-1380" />
    </div>;
}